import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"; // Assuming shadcn-ui's Card component is used
import { AlertTriangle } from "lucide-react"; // Assuming lucide-react is used for icons

const AccessDeniedPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [countdown, setCountdown] = useState(5); // Countdown starts at 5 seconds

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate(-1); // Redirect when countdown reaches 0
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer); // Cleanup on component unmount
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <Card className="max-w-md w-full">
        <CardHeader className="flex flex-col items-center">
          <AlertTriangle className="text-red-500 w-12 h-12 mb-4" />
          <CardTitle className="text-gray-800 text-2xl font-bold">
            {t("accessDenied.title")}
          </CardTitle>
          <CardDescription className="text-gray-600 text-lg">
            {t("accessDenied.message")}
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-gray-700 text-lg">
            {t("accessDenied.redirectMessage", { seconds: countdown })}
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessDeniedPage;